<template>
  <div class="logo">
    <div class="logo-container" style="backgroundImage: url('../static/images/nebo-logo.svg')"></div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name:"LogoBlock",
  components: {
  },
  data: () => ({

  })
}
</script>

<style lang="stylus" scoped>
  .logo
    position relative
    max-width 28.45%
    width 100%
    height auto

    &-container 
      padding-top 73.6%
      background-repeat no-repeat
      background-size contain

    // & img
    //   display block
    //   max-width 80%
    //   margin-left auto
    //   margin-right auto
      

</style>